import React, { useMemo } from "react";
import { StyleProp, StyleSheet, View, ViewStyle } from "react-native";
import { useDropdown } from "../hooks/use-dropdown";
import { IconName } from "./Icon";
import IconButton from "./IconButton";
import { useItemsDropdown } from "./Dropdown";

type HeaderActionsProps = {
    actions: MenuAction[];
    tintColor?: string;
    style?: StyleProp<ViewStyle>;
};

export type MenuAction = {
    label: string;
    icon: IconName;
    color?: string;
    style?: StyleProp<ViewStyle>;
    onPress: () => void;
    testID?: string;
};

const HeaderActions = ({ actions, tintColor, style }: HeaderActionsProps) => {
    const dropdownItems = useMemo(
        () =>
            actions?.map((action) => ({
                label: action.label,
                icon: action.icon,
                color: action.color,
                style: action.style,
                onClick: action.onPress,
                testID: action.testID,
            })) || [],
        [actions],
    );

    const dropdownComponent = useItemsDropdown({
        items: dropdownItems,
    });

    const dropdownProps = useDropdown({
        component: dropdownComponent,
    });
    return (
        <View style={[styles.actions, style]}>
            {actions.length == 1 ? (
                <IconButton
                    icon={actions[0].icon}
                    size={28}
                    iconColor={tintColor}
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    onPress={actions[0].onPress}
                    testID={actions[0].testID}
                />
            ) : (
                <IconButton
                    {...dropdownProps}
                    size={28}
                    icon="menu"
                    testID="stack-header-dropdown-menu"
                />
            )}
        </View>
    );
};

const styles = StyleSheet.create({
    actions: {
        flexGrow: 0,
    },
});

export default HeaderActions;
